import type { NavLeaf } from '@jarvis/platform-ui';
import type { OpsRole } from '../auth/roles';

export interface OpsNavLeaf extends NavLeaf {
  /** Visible when user has ItSysAdmin, OpsHRCompany, or OpsHRContract (exclusive of Pharmacy/Sales-only). */
  settingsAccess?: boolean;
  /** Entra App Role required to show this item (optional). ItSysAdmin sees all. */
  role?: OpsRole;
  /** Human Relations / Time Off subtree — visible when user has OpsHRCompany or OpsHRContract (or ItSysAdmin). */
  hrSection?: boolean;
  /** Visible when user has ItSysAdmin, OpsPharmacy, OpsFinance, or OpsSales. */
  securePharmReportsAccess?: boolean;
  /** Sales / Pharmacy menus while withheld from department roles — ItSysAdmin + OpsOperations. */
  unreleasedDepartmentAccess?: boolean;
  items?: OpsNavLeaf[];
}

export function filterNav(
  items: OpsNavLeaf[],
  access: {
    hasOpsRole: (role: OpsRole) => boolean;
    hasAnyHrRole: () => boolean;
    hasSecurePharmReportsAccess: () => boolean;
    hasSettingsPageAccess: () => boolean;
    hasUnreleasedDepartmentNavAccess: () => boolean;
  }
): OpsNavLeaf[] {
  const out: OpsNavLeaf[] = [];
  for (const node of items) {
    const kids = node.items ? filterNav(node.items, access) : undefined;
    const selfAllowed = node.unreleasedDepartmentAccess
      ? access.hasUnreleasedDepartmentNavAccess()
      : node.securePharmReportsAccess
        ? access.hasSecurePharmReportsAccess()
        : node.settingsAccess
          ? access.hasSettingsPageAccess()
          : node.hrSection === true
            ? access.hasAnyHrRole()
            : !node.role || access.hasOpsRole(node.role);
    const leaf = node.path !== undefined;
    if (leaf) {
      if (selfAllowed) out.push({ ...node, items: kids });
      continue;
    }
    if (selfAllowed && kids && kids.length > 0) {
      out.push({ ...node, items: kids });
    }
  }
  return out;
}
